export default {
	saleCountdown: 'Ends in {hours}h {minutes}m',
	saleCountdownFinalMinute: 'Ends in {seconds}s',
	saleOverProcessing: 'Sale over - processing',
	sold: 'Sold',
	underOffer: 'Under offer',
	unsold: 'Unsold',
};
